import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/services/Alert/alert.service';
import { UserService } from './../../services/User/user.service';
import { User } from '@app/model/user';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import Swiper from 'swiper';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  form!: FormGroup;
  userObj: User = new User();
  userList: User[] = [];

  //For Alert
  private subscription!: Subscription;
  alert: any;

  fieldTextType: boolean = false;
  fieldTextTypePass: boolean = false;
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
  
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private userService: UserService,
    private alertService: AlertService,
  ) { }

  onClickNavigation(route: string) {
    this.router.navigate([route]);
  }

  ngOnInit() {
    this.swiper();

    this.form = this.formBuilder.group({
      user_name: ['', Validators.compose([Validators.required, Validators.email])],
      password: ['', Validators.compose([Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}'), Validators.minLength(6)])],
      user_type: ['', Validators.required],
      active_indicator: [0],
      security_question: [''],
      security_answer: [''],
      phoneNumber: [''],
      i_agree_pp: [false],
      i_agree_tc: [false]
    });

    // For Alert
    this.subscription = this.alertService.onAlert()
      .subscribe(alert => {
        switch (alert?.type) {
          case 'success':
            alert.cssClass = 'alert alert-success';
            break;
          case 'error':
            alert.cssClass = 'alert alert-danger';
            break;
        }

        this.alert = alert;
        setTimeout(() => {
          alert = 'false';
        }, 10000);
      });
  }

  // Convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onSubmit() {
    // reset alerts on submit
    this.alertService.clear();

    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

    this.userObj = this.form.value;
    this.userService.register(this.userObj).subscribe(
      res => {
        Swal.fire({
          title: `Registered successfully  ${this.userObj.user_name}, please verify email.`,
          icon: "success",
          showConfirmButton: false,
          timer: 2000
        });
        // this.toastr.success(`Please login…! Registered successfully  ${this.userObj.user_name}`);
        // this.alertService.success('Congratulations, your account has been successfully created!', true);
        this.router.navigate(['login']);
      },
      error => {
        // this.alertService.error('Failed to register, The ' + this.userObj.user_name + ' email address is already used in a different account.');
        Swal.fire({
          title: `Email address is already used in a different account., Failed to register ${this.userObj.user_name}`,
          icon: "error",
          showConfirmButton: false,
          timer: 2000
        });
        // this.toastr.error('Email address is already used in a different account., ', 'Failed to register ' + this.userObj.user_name, {
        //   timeOut: 5000,
        // });
      }
    );
  }
  
  //Swiper
  swiper() {
    new Swiper(".mySwiper_photo", {
      spaceBetween: 30,
      effect: "fade",
      autoplay: {
        delay: 1000,
        disableOnInteraction: false,
      },
      keyboard: {
        enabled: true,
      }
    }); 
  }

  // ngAfterViewInit() {
  //   var a = $(".bg");
  //   a.each(function (a) {
  //       if ($(this).attr("data-bg")) $(this).css("background-image", "url(" + $(this).data("bg") + ")");
  //   });
  // }
}